export default __webpack_public_path__ + "images/tactics-and-strategies.svg";